import { firebaseConfig } from '@/config/firebase';
import { isBrowser } from '@/shared/utils/window';
import { getApps, initializeApp } from 'firebase/app';
import { connectAuthEmulator, getAuth } from 'firebase/auth';
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore';
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions';
import { connectStorageEmulator, getStorage } from 'firebase/storage';

export const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
export const auth = getAuth(app);
export const functions = getFunctions(app);
export const storage = getStorage(app);
export const firestoreDb = getFirestore(app);

if (isBrowser() && process.env.NEXT_PUBLIC_EMULATORS_ENABLED === 'true') {
  console.log('==================Firebase===============');

  // Auth
  connectAuthEmulator(auth, 'http://localhost:9099');
  console.log(
    'Emulating... Firebase "Auth".  Start Emulators and visit http://127.0.0.1:4000/auth'
  );

  // Firestore
  connectFirestoreEmulator(firestoreDb, 'localhost', 8080);
  console.log(
    'Emulating... Firebase "Firestore".  Start Emulators and visit http://127.0.0.1:4000/firestore'
  );

  // Storage
  connectStorageEmulator(storage, 'localhost', 9199);
  console.log(
    'Emulating... Firebase "Storage".  Start Emulators and visit http://127.0.0.1:4000/storage'
  );

  // Functions
  connectFunctionsEmulator(functions, 'localhost', 5001);
  console.log(
    'Emulating... Firebase "Functions".  Start Emulators and visit http://127.0.0.1:4000/functions'
  );
  console.log('==================/Firebase===============');
}
